import polylabel from 'polylabel'
import L from 'leaflet'

const getLargestPolygonCoords = geom => {
  if (geom.type !== 'MultiPolygon') return geom.coordinates

  return geom.coordinates.reduce(
    (largest, poly) => {
      const ring = poly[0]
      const lats = ring.map(p => p[1])
      const lngs = ring.map(p => p[0])
      const area =
        (Math.max(...lats) - Math.min(...lats)) * (Math.max(...lngs) - Math.min(...lngs))
      return area > largest.area ? { poly, area } : largest
    },
    { poly: geom.coordinates[0], area: 0 }
  ).poly
}

// Upper portion of the district — keeps the active label out of the center
// where property clusters usually sit, without sitting on the northern edge.
const getTopBoundaryPosition = geography => {
  const ring = getLargestPolygonCoords(geography.data.geometry)[0]
  const lats = ring.map(p => p[1])
  const lngs = ring.map(p => p[0])
  const maxLat = Math.max(...lats)
  const minLat = Math.min(...lats)
  const latSpan = maxLat - minLat
  const insetFromTop = latSpan * 0.18
  const targetLat = maxLat - insetFromTop
  const latBand = Math.max(latSpan * 0.06, 0.001)
  const bandPoints = ring.filter(
    p => p[1] >= targetLat - latBand && p[1] <= targetLat + latBand
  )
  const lng = bandPoints.length
    ? bandPoints.reduce((sum, p) => sum + p[0], 0) / bandPoints.length
    : (Math.min(...lngs) + Math.max(...lngs)) / 2

  return L.latLng(targetLat, lng)
}

// Bounding-box center can fall outside irregular districts (e.g. AD 27's anchor
// lands inside AD 40). Polylabel finds the pole of inaccessibility — guaranteed
// inside the polygon — which is the standard approach for map labels.
const getGeographyLabelPosition = (geography, { atTop = false } = {}) => {
  if (atTop) return getTopBoundaryPosition(geography)

  const polygonCoords = getLargestPolygonCoords(geography.data.geometry)
  const [lng, lat] = polylabel(polygonCoords, 0.000001)
  return L.latLng(lat, lng)
}

export default getGeographyLabelPosition
